<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <div class="dropdown profile-element m-b-md">
            <div id="logo-big">
              <img src="/static/img/toolbox.png" alt="Lynx" width="100" align="center">
            </div>
            <a class="dropdown-toggle">
              <span class="block m-t-xs font-bold">
                <i class="fa fa-star red" v-if="user.master"/>
                <i class="fa fa-star yellow" v-else-if="user.admin"/>
                {{ $store.state.user.username }}</span>
            </a>
          </div>
          <div class="logo-element white">
            <img src="/static/img/toolbox.png" alt="Toolbox" width="40" align="center">
          </div>
          <div class="small"></div>
        </li>
        <li class="active">
          <a href=""><i class="fas fa-sitemap"></i><span class="nav-label"> PBN</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/pbn/dashboard'}" tag="li" exact>
              <a><i class="far fa-eye"></i> Dashboard</a>
            </router-link>
            <router-link :to="{path: '/pbn'}" tag="li" exact>
              <a><i class="fas fa-server"></i> Pbns</a>
            </router-link>
            <router-link :to="{path: '/lists/tech'}" tag="li" exact>
              <a><i class="fas fa-beer"></i> Tech View</a>
            </router-link>
            <router-link :to="{path: '/lists/seo'}" tag="li" exact>
              <a><i class="fas fa-chart-line"></i> SEO View</a>
            </router-link>
            <router-link :to="{path: '/pbn/footprint-manager'}" tag="li" exact>
              <a><i class="fas fa-shoe-prints"></i> Footprints</a>
            </router-link>
            <router-link :to="{path: '/pbn/builds'}" tag="li" exact v-if="user.admin || user.roles.length">
              <a><i class="fas fa-hammer"></i> Builds</a>
            </router-link>
            <router-link :to="{path: '/pbn/orders'}" tag="li" exact v-if="user.admin">
              <a><i class="fas fa-shopping-cart"></i> Orders</a>
            </router-link>
            <router-link :to="{path: '/pbn/builds/queue'}" tag="li" exact v-if="user.admin || user.roles.length > 0">
              <a><i class="fas fa-filter"></i> Build Queue</a>
            </router-link>
            <router-link :to="{path: '/pbn/reports'}" tag="li" exact>
              <a><i class="fas fa-server"></i> Reports</a>
            </router-link>
            <router-link :to="{path: '/pbn/domains'}" tag="li" exact v-if="user.admin">
              <a><i class="fas fa-crosshairs"></i> Domains</a>
            </router-link>
             <router-link :to="{path: '/ip-overview'}" tag="li" exact v-if="user.admin">
              <a><i class="fa fa-server"></i> IP Overview</a>
            </router-link>
            <router-link :to="{path: '/pbn/templates'}" tag="li" exact v-if="user.admin && user.id === 1">
              <a><i class="fas fa-cubes"></i> Templates</a>
            </router-link>
            <router-link :to="{path: '/reports'}" tag="li" exact v-if="user.admin && user.username === 'rok'">
              <a><i class="fas fa-cubes"></i> Reports</a>
            </router-link>
          </ul>
        </li>
        <li class="active">
          <a href=""><i class="fa-solid fa-diagram-project"></i><span class="nav-label"> Task Manager</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/task-manager/projects'}" tag="li" exact>
              <a><i class="fa fa-list"></i> Projects</a>
            </router-link>
            <router-link to="/task-manager/tasks" tag="li" exact><a><i class="fas fa-tasks"></i> Tasks</a></router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin || user.roles.length">
          <a href=""><i class="fas fa-hammer"></i><span class="nav-label"> Maintenance</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/maintenance/orders'}" tag="li" exact v-if="user.admin">
              <a><i class="fas fa-shopping-cart"></i> Orders</a>
            </router-link>
            <router-link to="/maintenance/tasks" tag="li" exact><a><i class="fas fa-tasks"></i> Tasks</a></router-link>
          </ul>
        </li>
        <li class="active">
          <a href=""><i class="fas fa-link"></i><span class="nav-label"> Link Building</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/pbn/link-orders'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Orders</a>
            </router-link>
            <router-link :to="{path: '/pbn/link-tags'}" tag="li" exact  v-if="user.admin">
              <a><i class="fas fa-tags"></i> Tags</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin">
          <a href=""><i class="fas fa-link"></i><span class="nav-label"> Search Console</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/search-console'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Search Console</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.roles.includes('ppc')">
          <a href=""><i class="fas fa-link"></i><span class="nav-label"> PPC</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/ppc/orders'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Orders</a>
            </router-link>
            <router-link :to="{path: '/ppc/accounts'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Accounts</a>
            </router-link>
            <router-link :to="{path: '/ppc/clients'}" tag="li" exact>
              <a><i class="fas fa-user"></i> Clients</a>
            </router-link>
            <router-link :to="{path: '/ppc/cards'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Cards</a>
            </router-link>
            <router-link :to="{path: '/ppc/rdp'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> RDP</a>
            </router-link>
            <router-link :to="{path: '/ppc/transactions'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Transactions</a>
            </router-link>
            <router-link :to="{path: '/ppc/groups'}" tag="li" exact>
              <a><i class="fas fa-shopping-cart"></i> Groups</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin || (user.clients.length && !user.groups.length)">
          <a href=""><i class="far fa-list-alt"></i><span class="nav-label">Accounts</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/service-accounts'}" tag="li">
              <a><i class="fas fa-key"></i> Services</a>
            </router-link>
            <router-link :to="{path: '/account/registrars'}" tag="li" exact>
              <a><i class="fas fa-magic"></i> Registrars</a>
            </router-link>
            <router-link :to="{path: '/account/hosts'}" tag="li" exact>
              <a><i class="fas fa-h-square"></i> Hosts</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin">
          <a href=""><i class="fas fa-toolbox"></i><span class="nav-label">Toolbox</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/std/index-checker'}" tag="li" exact>
              <a><i class="fas fa-tasks"></i>Index Checker</a>
            </router-link>
            <router-link :to="{path: '/toolbox/site-grader'}" tag="li" exact>
              <a><i class="fas fa-graduation-cap"></i>Site Grader</a>
            </router-link>
            <router-link :to="{path: '/toolbox/site-checker'}" tag="li" exact>
              <a><i class="far fa-eye"></i>Site Checker</a>
            </router-link>
            <router-link :to="{path: '/toolbox/google-index-helper'}" tag="li" exact>
              <a><i class="fab fa-google"></i>Google Index Helper</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.master || user.roles.includes('xero-read') || user.roles.includes('xero-write')">
          <a href=""><i class="fa fa-cash-register"></i><span class="nav-label">Billing</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/admin/billing'}" tag="li" exact>
              <a><i class="fa fa-money"></i>Billing</a>
            </router-link>
            <router-link :to="{path: '/admin/billing/invoices'}" tag="li" exact>
              <a><i class="fa fa-file-invoice"></i>Invoices</a>
            </router-link>
            <router-link :to="{path: '/admin/billing/items'}" tag="li" exact>
              <a><i class="fa fa-gift"></i>Products</a>
            </router-link>
            <router-link :to="{path: '/admin/billing/contacts'}" tag="li" exact>
              <a><i class="fa fa-users"></i>Contacts</a>
            </router-link>
            <router-link :to="{path: '/admin/billing/accounts'}" tag="li" exact>
              <a><i class="fa fa-list"></i>Accounts</a>
            </router-link>
            <router-link :to="{path: '/admin/billing/tracking'}" tag="li" exact>
              <a><i class="fa fa-flag-checkered"></i>Tracking</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin">
          <a href=""><i class="fa-regular fa-rectangle-ad"></i><span class="nav-label">Advertising</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/advertisers/affiliatecompanies'}" tag="li" exact>
              <a><i class="fa-solid fa-building"></i>Affiliate Companies</a>
            </router-link>
            <router-link :to="{path: '/advertisers/brands'}" tag="li" exact>
              <a><i class="fas fa-tasks"></i>Brands</a>
            </router-link>
            <router-link :to="{path: '/advertisers/toplists'}" tag="li" exact>
              <a><i class="fas fa-table-list"></i>Toplists</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin && user.master">
          <a href=""><i class="fas fa-star yellow"></i><span class="nav-label">Admin</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/admin/users'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Users</a>
            </router-link>
            <router-link :to="{path: '/admin/clients'}" tag="li" exact>
              <a><i class="fas fa-user-group"></i>Clients</a>
            </router-link>
            <router-link :to="{path: '/admin/roles'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>User Roles</a>
            </router-link>
            <router-link :to="{path: '/admin/requests'}" tag="li" exact>
              <a><i class="fas fa-exchange-alt"></i>Requests</a>
            </router-link>
            <router-link :to="{path: '/admin/data'}" tag="li" exact>
              <a><i class="fa fa-database"></i>Data</a>
            </router-link>
            <router-link :to="{path: '/admin/data-lists'}" tag="li" exact>
              <a><i class="fa-sharp fa-solid fa-list"></i>Data Lists</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.master || user.roles.includes('operator')">
          <a href=""><i class="fas fa-cog"></i><span class="nav-label">Account</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/account/users'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Users</a>
            </router-link>
            <router-link :to="{path: '/account/billing'}" tag="li" exact>
              <a><i class="fas fa-money-bill"></i>Billing</a>
            </router-link>
          </ul>
        </li>
        <li class="active" v-if="user.admin || user.roles.includes('operator')">
          <a href=""><i class="fas fa-i"></i><span class="nav-label">Instalinko</span> <span class="fa arrow"></span></a>
          <ul class="nav nav-second-level collapse">
            <router-link :to="{path: '/instalinko/webmasters'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Webmasters</a>
            </router-link>
            <router-link :to="{path: '/instalinko/writers'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Writers</a>
            </router-link>
            <router-link :to="{path: '/instalinko/inventory'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Inventory</a>
            </router-link>
            <router-link :to="{path: '/instalinko/orders'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Orders</a>
            </router-link>
            <router-link :to="{path: '/instalinko/clients'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Clients</a>
            </router-link>
            <router-link :to="{path: '/instalinko/reports'}" tag="li" exact>
              <a><i class="fas fa-users-cog"></i>Reports</a>
            </router-link>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
  name: 'Menu',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
  }
}
</script>

<style>
.yellow {
  color: yellow;
}
#logo-big {
  text-align: center;
}
.white {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Menu.vue